// import variables from '../variables';
/* eslint-disable */
const MuiMenu = {
  list: {
    padding: 0,
  },
};

export default MuiMenu;
